import React, { createContext, useContext, useState, useCallback } from 'react';
import { getSavedItems, saveItem, unsaveItem } from '../services/savedItems';

const SavedItemsContext = createContext();

export const SavedItemsProvider = ({ children }) => {
  const [savedItems, setSavedItems] = useState({
    course: [],
    event: [],
    document: []
  });
  const [loading, setLoading] = useState(false);

  const loadSavedItems = useCallback(async (itemType) => {
    setLoading(true);
    try {
      const items = await getSavedItems(itemType);
      setSavedItems(prev => ({
        ...prev,
        [itemType]: items
      }));
    } catch (error) {
      console.error('Error loading saved items:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  const saveNewItem = useCallback(async (itemType, itemId) => {
    try {
      await saveItem(itemType, itemId);
      // Reload the saved items for this type to get updated list
      loadSavedItems(itemType);
    } catch (error) {
      console.error('Error saving item:', error);
    }
  }, [loadSavedItems]);

  const removeItem = useCallback(async (itemType, itemId) => {
    try {
      await unsaveItem(itemType, itemId);
      // Update local state to reflect the removal
      setSavedItems(prev => ({
        ...prev,
        [itemType]: prev[itemType].filter(item => item.id !== itemId)
      }));
    } catch (error) {
      console.error('Error removing saved item:', error);
    }
  }, []);

  return (
    <SavedItemsContext.Provider value={{ 
      savedItems, 
      loading, 
      loadSavedItems, 
      saveItem: saveNewItem,
      removeItem 
    }}>
      {children}
    </SavedItemsContext.Provider>
  );
};

export const useSavedItems = () => useContext(SavedItemsContext);